// support ticket deep links, and the app-level modal they open.
//
// notifications, emails and Slack link to a ticket as
//   /help_center?tab=support&ticket_id=N[&tenant_id=T]      (current)
//   /support_ticket_details?tenant_id=T&id=N                  (legacy)
// possibly absolute (https://web.../#/...) or hash-prefixed (#/...). a click
// inside the app on one of these should open the ticket in place rather
// than route away from whatever the viewer was doing: App.vue hosts one
// SupportTicketModal and listens for the root event emitted here.

const TICKET_PATHS = ['/help_center', '/support_ticket_details']

// { id, tenant_id } when `dest` points at a support ticket, else null.
// tenant_id may be '' -- the api falls back to id-only lookup.
export function parseSupportTicketLink(dest) {
  if (!dest || typeof dest !== 'string') return null
  let s = dest.trim()
  if (!s) return null
  // absolute url: keep only what follows the hash router's '#'
  if (/^https?:\/\//i.test(s)) {
    const hash = s.indexOf('#')
    if (hash === -1) return null
    s = s.slice(hash + 1)
  }
  if (s.startsWith('#')) s = s.slice(1)
  const q = s.indexOf('?')
  const path = (q === -1 ? s : s.slice(0, q)).replace(/\/+$/, '') || '/'
  if (!TICKET_PATHS.includes(path)) return null
  const params = new URLSearchParams(q === -1 ? '' : s.slice(q + 1))
  const id = params.get('ticket_id') || params.get('id')
  if (!id || !/^\d+$/.test(id)) return null
  if (path === '/help_center' && params.get('tab') && params.get('tab') !== 'support') return null
  return { id, tenant_id: params.get('tenant_id') || '' }
}

// open the ticket in the app-level modal (App.vue listens on the root bus)
export function openSupportTicket(vm, ref) {
  vm.$root.$emit('open-support-ticket', { tenant_id: ref.tenant_id || '', id: ref.id })
}
